import client from "../index.js";
import { GET_JOURNALS } from "./query.js";
import {
  CREATE_JOURNAL,
  UPSERT_JOURNAL,
  UPDATE_JOURNAL,
  DELETE_JOURNAL,
  CANCEL_JOURNAL_REMINDER,
} from "./mutation.js";

export const apiGetJournals = (input) => {
  return client
    .query({
      query: GET_JOURNALS,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["journals"]);
};

export const apiCreateJournal = (input) => {
  return client
    .mutate({
      mutation: CREATE_JOURNAL,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["createJournal"]);
};

export const apiUpsertJournal = (input) => {
  return client
    .mutate({
      mutation: UPSERT_JOURNAL,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["upsertJournal"]);
};

export const apiUpdateJournal = (input) => {
  return client
    .mutate({
      mutation: UPDATE_JOURNAL,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["updateJournal"]);
};

export const apiDeleteJournal = (id) => {
  return client
    .mutate({
      mutation: DELETE_JOURNAL,
      variables: { id },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["deleteJournal"]);
};

export const apiCancelJournalReminder = (id) => {
  return client
    .mutate({
      mutation: CANCEL_JOURNAL_REMINDER,
      variables: { id },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["cancelJournalReminder"]);
};
